module.exports = __webpack_public_path__ + "src/routes/forgetpwd/pic.png?ff5bc782";


//////////////////
// WEBPACK FOOTER
// ./src/routes/forgetpwd/pic.png
// module id = 2842
// module chunks = 1